<template>
  <div id="login" :class="popupClasses">
    <div class="close__wrapper close__wrapper-center">
      <div class="popup__close" @click.prevent="closeModal(modal.name)">
        <img alt="image" src="@/assets/img/new/close.svg" />
      </div>
      <div class="header__popup column">
        <span class="header__popup-title">{{ modal.title }}</span>
        <span class="header__popup-text" v-if="modal.message">{{
          modal.message
        }}</span>
      </div>
      <div class="footer__popup" @submit.prevent="Restore()">
        <button class="redbtn" @click.prevent="closeModal(modal.name)">
          ОК
        </button>
      </div>
    </div>
    <!-- <div class="popup__header">
      {{ modal.title }}
    </div>
    <div class="popup__body">
      <p class="popup__message">{{ modal.message }}</p>
      <button
        class="btn btn__blue popup__login-btn"
        @click.prevent="closeModal(modal.name)"
      >
        ОК
      </button>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
//
export default {
  name: "LoginModal",
  props: ["modal", "bg"],
  computed: {
    popupClasses() {
      if (window.screen.width < 680) {
        return ["mobpopup"];
      } else {
        return ["popup"];
      }
    }
  },
  methods: {
    ...mapActions("modals", ["closeModal"])
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/ui/Modals/Info.vue